import { Component, Ref } from "@eastsideco/salvo-ts";
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class VoyadoSearchModal extends ThemeComponent {
    @Ref closeButton!: HTMLButtonElement;
    @Ref searchForm!: HTMLInputElement;

    init() {
        // document.addEventListener('mobileSearchOpen', () => {
        //     this.showModal();
        // });

        this.$listen(this.closeButton, 'click', () => {
            this.hideModal();
        });
    }

    showModal() {
        this.classList.add('voyado-search-modal--open');
        document.body.classList.add('search-open');
        document.documentElement.classList.add('search-open');
        this.searchForm.focus();
    }

    hideModal() {
        this.classList.remove('voyado-search-modal--open');
        document.body.classList.remove('search-open');
        document.documentElement.classList.remove('search-open');
        this.searchForm.blur();
    }
}
